import { autoinject } from "aurelia-framework";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { WebApiService } from "../services/web-api-service";
import { SecurityService } from "../services/security-service";
import { BroadcastMessage } from "../models/signalr-broadcast-message";

export enum PushMessage {
    CarrierUpdated = 0,
    InsuranceUpdated = 1,
    CarrierStatusChanged = 2,
    CarrierDocumentsUpdated = 3
}

@autoinject()
export class SignalrService {

    signalR: any = window["signalR"];
    connection: any;
    constructor(
        private ea: EventAggregator,
        private security: SecurityService) {
    }

    //broadcast message to all connected clients.
    broadcast(messageType: PushMessage, data: any) {
        this.connection.invoke('Broadcast', messageType, data);
    }

    // subscribe to any notification messages that are intended for this client.
    listen(messageType: PushMessage, callback: (msg: BroadcastMessage) => void) {
        if (this.signalR) {
            return this.ea.subscribe(`signal-r.${messageType}`, callback);
        }
    }

    unlisten(sub: Subscription) {
        sub.dispose();
    }

    hubConnection: any;

    init() {
        if (this.signalR) {
            this.createHubConnection();
            return this.connect();
        }
    }

    connect() {
        return this.hubConnection.start().then(() => {
            console.log('SignalR Connection Successful');
        }, (e) => {
            console.log('SignalR Connection Failed.  Retry pending...');
            setTimeout(() => this.reconnect(), 10000);
        });
    }

    createHubConnection() {
        //let transportType = this.signalR.TransportType.LongPolling;
        //this.hubConnection = new this.signalR.HubConnection("/cmpHub", { transport: transportType });

        this.hubConnection = new this.signalR.HubConnectionBuilder()
            .withUrl("/cmpHub", {
                // "Foo: Bar" will not be sent with WebSockets or Server-Sent Events requests
                //headers: { "Foo": "Bar" },
                transport: this.signalR.HttpTransportType.LongPolling
            })
            .build();


        this.hubConnection.on('broadcast', (msg) => {

            msg.isThisUser = this.security.user.userName == msg.userName;
            //if (!msg.isThisUser) debugger;
            this.ea.publish(`signal-r.${msg.message}`, msg);
        });

        this.hubConnection.onclose(e => {
            if (e) {
                console.log('Connection closed with error: ' + e + ".  Will try to reconnect...");
            }
            else {
                console.log('Connection disconnected.  Reconnect pending...');
            }
            setTimeout(() => this.reconnect(), 10000);
        });
    }

    reconnect() {
        delete this.hubConnection.closedCallbacks;
        delete this.hubConnection;
        this.init();
    }

}